import { Component, OnDestroy, OnInit } from '@angular/core';
import { config, AnnouncementService, MemberQuery, PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { TPFService } from 'src/app/model/tpf/tpf.service';
import { calculateAge, getKidType, KidTypeE, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';
import { Tags } from 'src/app/shared/utilities/tags';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit, OnDestroy {
  config = config;
  screenSize = ScreenType;
  memberInfo$: Observable<{ firstName: string; kidType: KidTypeT }>;
  populations = Populations;
  isKid: boolean;
  isSTHMember: boolean;
  isClub1901: boolean;
  KidType = KidTypeE;
  shopURL: string;
  private _destroyed$ = new Subject<void>();
  tags = Tags;

  constructor(
    private announcementService: AnnouncementService,
    private memberQuery: MemberQuery,
    private populationQuery: PopulationQuery,
    private tpfService: TPFService
  ) {}

  ngOnInit() {
    this.memberInfo$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          const age = calculateAge(new Date(m.DOB));
          const kidType = getKidType(age);
          return { firstName: m.FirstName, kidType };
        }
        return { firstName: '', kidType: 'Other' };
      })
    );
    firstValueFrom(this.announcementService.fetchAnnouncements());
    this.isKid = this.populationQuery.userInPopulation([this.populations.Kids]);
    this.isSTHMember = this.populationQuery.userInPopulation([this.populations.Default]);
    this.isClub1901 = this.populationQuery.userInPopulation([this.populations.Club1901]);
  }

  launchShop(url: string) {
    this.tpfService.sso(1, url);
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
